module.exports = __webpack_public_path__ + "media/level4-siren.eed5ce3c.mp3";